export default __webpack_public_path__ + "madfit-screen-second@2x.c4cbcc2f.png";